import { type ReactNode } from 'react';
import { Button, ICON_COLOR } from '@zep-us/zus';
import { ChevronDownIcon, MagnifingglassIcon } from '@zep-us/zus-icons';
import { cn } from '@/utils/tailwind.util';
import { AiBuilderShineText } from './AiBuilderShineText';

/** 진행 중 — 돋보기 아이콘 + shine 텍스트. 아이콘은 gradient 밖 형제로 둔다. */
const Running = ({
  children
}: {
  children: ReactNode;
}) => <div className="flex min-h-10 min-w-10 items-center gap-xs whitespace-normal rounded-full px-sm text-body-lg-semibold" data-sentry-component="Running" data-sentry-source-file="AiBuilderProgressTitle.tsx">
    <MagnifingglassIcon size="xs" fill={ICON_COLOR.alternative} data-sentry-element="MagnifingglassIcon" data-sentry-source-file="AiBuilderProgressTitle.tsx" />
    <AiBuilderShineText data-sentry-element="AiBuilderShineText" data-sentry-source-file="AiBuilderProgressTitle.tsx">{children}</AiBuilderShineText>
  </div>;

/** 종료(완료/중단) + 스텝 있음 — 접기/펼치기 토글 버튼. */
const Toggle = ({
  ariaControls,
  children,
  collapsed,
  onToggle
}: {
  ariaControls: string;
  children: ReactNode;
  collapsed: boolean;
  onToggle: () => void;
}) => <Button type="button" variant="transparent" intent="neutral" size="md" rounded="full" aria-controls={ariaControls} aria-expanded={!collapsed} onClick={onToggle} className="min-h-10 min-w-0 justify-start rounded-none border-0 !bg-transparent py-0 text-alternative hover:!bg-transparent focus:!bg-transparent active:!bg-transparent" rightSlot={<ChevronDownIcon size="sm" fill="currentColor" className={cn('transition-transform duration-150 ease-out', !collapsed && 'rotate-180')} />} data-sentry-element="Button" data-sentry-component="Toggle" data-sentry-source-file="AiBuilderProgressTitle.tsx">
    {children}
  </Button>;

/** 종료 + 스텝 없음 — 토글 불가 라벨. */
const Static = ({
  children
}: {
  children: ReactNode;
}) => <div className="flex min-h-10 min-w-0 cursor-default items-center gap-xs px-sm text-body-md-semibold text-alternative" data-sentry-component="Static" data-sentry-source-file="AiBuilderProgressTitle.tsx">
    <span className="whitespace-nowrap">{children}</span>
  </div>;
export const AiBuilderProgressTitle = {
  Running,
  Toggle,
  Static
};